import { CONTRACT_STATE_DRAFT, CONTRACT_TYPES } from '../settings';

export const ALL_PAGESIZE = 99999;
export const ALL_ORGS_CONTEXT = { id: 0, name: 'ALL ORGANIZATIONS' };
export const ALL_SELECT_OPTION = { value: 0, label: 'ALL' };
export const ALL_ID = 'all';
export const ALL_PERFORMANCES_OPTIONS = { id: JSON.stringify({ id: ALL_ID, name: 'ALL' }), name: 'ALL' };
export const PHONE_TYPES = ['mobile', 'home', 'private', 'work'];
export const SOCIAL_MEDIA_TYPES = ['facebook', 'instagram', 'linkedin', 'twitter'];
export const PARTNER_CATEGORIES = [
    { label: 'Audio', value: 'audio' },
    { label: 'Audiovisual', value: 'audiovisual' }
];

export const TEMP_ID_PREFIX = 'TEMP_ID_';

export const UNLIMITED_DATE = 32503680000000;

export const RT_TYPE_EMAIL = 'email';
export const RT_TYPE_CONTRACT = 'contract';

export const ADDRESS_FIELDS = {
    address1: '',
    address2: '',
    postalCode: '',
    city: '',
    stateProvince: '',
    country: ''
};
export const MODELS = {
    ARTIST: 'artist',
    ORGANIZATION: 'organization',
    PARTNER: 'partner',
    USER: 'user',
    STAGE: 'stage',
    EVENT: 'event',
    IMPORT: 'import',
    CONTACT: 'contact',
    CONTRACT: 'contract',
    CONTRACT_DRAFT: 'contractDraft',
    PERMISSION: 'permission',
    CONTRACT_PARTNER: 'contractPartner',
    EVENT_PARTNER: 'eventPartner',
    EVENT_ARTIST: 'eventArtist',
    EVENT_EMAIL: 'eventEmail',
    EVENT_REMINDER: 'eventReminder',
    ADDRESS: 'address',
    TEMPLATE: 'template',
    ENTRY: 'scheduledEntry',
    DEFAULT: 'default',
    ARTIST_PARTNER_CONTACT: 'artistContact',
    ARTIST_CONTACTS: 'artist_contacts',
    BULK_PERFORMANCE: 'bulkPerformance',
    BULK_PARTNERS_EMAIL: 'bulkPartnersEmail',
    CONTRACT_REMINDER: 'contractReminder',
    CONTRACT_UPLOAD: 'contractUpload',
    EVENT_EMAIL_SENDER: 'eventEmailSender',
    COPY_PARTNER_CLEARANCE: 'copyPartnerClearance'
};

export const MODEL_INITIAL_VALUES = {
    [MODELS.EVENT_EMAIL_SENDER]: { name: '', email: '' },
    [MODELS.CONTACT]: {
        email: '',
        fullName: '',
        phones: [{ k: PHONE_TYPES[0], v: '' }],
        socialMedia: [{ k: SOCIAL_MEDIA_TYPES[0], v: '' }],
        website: '',
        image: '',
        note: '',
        organizationIds: [],
        partnerIds: [],
        artistIds: []
    },
    [MODELS.ARTIST_CONTACTS]: {
        list: [],
        fullName: '',
        email: '',
        id: '',
        type: 'artist',
        permission: '',
        accessToPerformanceContracts: false
    },
    [MODELS.EVENT]: {
        name: '',
        organizationId: '',
        timeZone: '',
        start: null,
        end: null,
        chatEnabled: false,
        ...ADDRESS_FIELDS
    },
    [MODELS.ARTIST]: {
        name: '',
        socialMedia: [{ k: SOCIAL_MEDIA_TYPES[0], v: '' }],
        website: '',
        image: '',
        organizationIds: [],
        eventIds: [],
        tags: [],
        note: ''
    },
    [MODELS.PARTNER]: {
        name: '',
        timeZone: '',
        website: '',
        socialMedia: [{ k: SOCIAL_MEDIA_TYPES[0], v: '' }],
        description: '',
        image: '',
        organizationIds: [],
        eventIds: [],
        ...ADDRESS_FIELDS
    },
    [MODELS.ORGANIZATION]: {
        name: '',
        timeZone: '',
        country: '',
        ...ADDRESS_FIELDS
    },
    [MODELS.CONTRACT]: {
        clearing: [],
        comments: '',
        notes: '',
        editing: false,
        archived: false,
        eventId: '',
        organizationId: '',
        type: CONTRACT_TYPES.CLEARANCE,
        dueDate: null,
        logo: '',
        performances: [],
        artistId: '',
        signers: '',
        fetchingSignersFor: null,
        fetchedSignersFor: null,
        version: { state: CONTRACT_STATE_DRAFT }
    },
    [MODELS.TEMPLATE]: {
        name: '',
        organizationId: '',
        data: '',
        logo: '',
        type: '',
        clearing: {}
    },
    [MODELS.ENTRY]: {
        stageIdentifier: '',
        artistId: '',
        start: '',
        end: '',
        clearing: []
    },
    [MODELS.EVENT_EMAIL]: {
        content: '',
        eventId: '',
        humanType: '',
        id: '',
        isGroup: false,
        receiver: '',
        sender: '',
        subject: '',
        type: '',
        senderName: ''
    },
    [MODELS.EVENT_REMINDER]: {
        name: '',
        template: '',
        contractType: CONTRACT_TYPES.CLEARANCE,
        dueDate: ''
    }
};

export const TIMEZONES = {
    'Etc/GMT+12': 'International Date Line West',
    'Pacific/Midway': 'Midway Island, Samoa',
    'Pacific/Honolulu': 'Hawaii',
    'America/Juneau': 'Alaska',
    'America/Dawson': 'Pacific Time (US and Canada)',
    'America/Boise': 'Mountain Time (US and Canada)',
    'America/Phoenix': 'Arizona',
    'America/Chicago': 'Central Time (US and Canada)',
    'America/Mexico_City': 'Guadalajara, Mexico City, Monterrey',
    'America/Belize': 'Central America',
    'America/Detroit': 'Eastern Time (US and Canada)',
    'America/Glace_Bay': 'Atlantic Time (Canada)',
    'America/Santiago': 'Santiago',
    'America/Sao_Paulo': 'Brasilia',
    'America/Argentina/Buenos_Aires': 'Buenos Aires, Georgetown',
    'America/Godthab': 'Greenland',
    'Etc/GMT+2': 'Mid-Atlantic',
    'Atlantic/Cape_Verde': 'Cape Verde Islands',
    GMT: 'Dublin, Edinburgh, Lisbon, London',
    'Africa/Casablanca': 'Casablanca, Monrovia',
    'Europe/Belgrade': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    'Europe/Sarajevo': 'Sarajevo, Skopje, Warsaw, Zagreb',
    'Europe/Brussels': 'Brussels, Copenhagen, Madrid, Paris',
    'Europe/Amsterdam': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    'Africa/Algiers': 'West Central Africa',
    'Europe/Bucharest': 'Bucharest',
    'Europe/Helsinki': 'Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
    'Europe/Athens': 'Athens, Istanbul, Minsk',
    'Asia/Jerusalem': 'Jerusalem',
    'Europe/Moscow': 'Moscow, St. Petersburg, Volgograd',
    'Asia/Tehran': 'Tehran',
    'Asia/Dubai': 'Abu Dhabi, Muscat',
    'Asia/Baku': 'Baku, Tbilisi, Yerevan',
    'Asia/Yekaterinburg': 'Ekaterinburg',
    'Asia/Karachi': 'Islamabad, Karachi, Tashkent',
    'Asia/Kolkata': 'Chennai, Kolkata, Mumbai, New Delhi',
    'Asia/Dhaka': 'Astana, Dhaka',
    'Asia/Rangoon': 'Yangon Rangoon',
    'Asia/Bangkok': 'Bangkok, Hanoi, Jakarta',
    'Asia/Krasnoyarsk': 'Krasnoyarsk',
    'Asia/Shanghai': 'Beijing, Chongqing, Hong Kong SAR, Urumqi',
    'Asia/Kuala_Lumpur': 'Kuala Lumpur, Singapore',
    'Asia/Seoul': 'Seoul',
    'Asia/Tokyo': 'Osaka, Sapporo, Tokyo',
    'Australia/Darwin': 'Darwin',
    'Australia/Adelaide': 'Adelaide',
    'Australia/Sydney': 'Canberra, Melbourne, Sydney',
    'Australia/Brisbane': 'Brisbane',
    'Asia/Vladivostok': 'Vladivostok',
    'Asia/Magadan': 'Magadan, Solomon Islands, New Caledonia',
    'Pacific/Fiji': 'Fiji Islands, Kamchatka, Marshall Islands',
    'Pacific/Auckland': 'Auckland, Wellington'
};

export const HTML_CLASSES = {
    RTE_COMMENTS: 'is-with-comment',
    RTE_JS_COMMENTS: 'js-with-comment'
};

export const JOB_FUNCTIONS = ['artist', 'organization', 'partner'];

export const ADMIN_LIST_VIEW_HEADERS = [
    { label: 'Stage', key: 'stageName' },
    {
        label: 'Artist',
        key: 'artistName'
    },
    { label: 'Performance Date', key: 'date' }
];

export const BULK_PERFORMANCE_TYPES = {
    LIVE: 'live',
    NON_LINEAR: 'nonLinear',
    COMMENTS: 'comments',
    USE_UNTIL: 'useUntil'
};



// WEBPACK FOOTER //
// ./src/constants/admin/settings.js